const state = () => ({
  people: [],
  clusters: [],
  pageItems: [],
  totalRowCount: 0,
  loading: false
});

export default state;
